import Vue from "vue";
import VCalendar from 'v-calendar';
import vSelect from "vue-select";

import App from "./App.vue";
import "./assets/tailwind.css";

import router from "./router/index";
import store from "./store/index";

import LS from "./helpers/localStorage";
import kuid from "kuid";

import * as Sentry from "@sentry/vue";

if (!LS.getItem("person")) {
  window.person = {
    id: kuid()
  };
  LS.setItem("person", window.person);
} else {
  window.person = LS.getItem("person");
}

Vue.config.productionTip = false;
Vue.component("v-select", vSelect);

// Use v-calendar & v-date-picker components
Vue.use(VCalendar, {
  componentPrefix: 'vc',  // Use <vc-calendar /> instead of <v-calendar />
});

Sentry.init({
  Vue,
  dsn: process.env.VUE_APP_SENTRY_DSN,
  environment: process.env.VUE_APP_SENTRY_ENVIRONMENT,
  integrations: [
    Sentry.browserTracingIntegration({ router }),
    Sentry.captureConsoleIntegration({
      levels: ['error'],
    }),
  ],
  tracesSampleRate: 1.0,
});

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
